import React from "react";
import {
    Box,
    SimpleGrid,
    Heading,
    Text,
    useColorModeValue,
    useDisclosure
} from "@chakra-ui/react";
import DataTableCard from "./components/DataTableCard";
import MonthlyTransfersModal from "./components/MonthlyTransfersModal";
import FailedLoginsModal from "./components/FailedLoginsModal";

import TransfersFunnelModal from "./components/TransfersFunnelModal";
import RegistrationFunnelModal from "./components/RegistrationFunnelModal";
import NewUsersModal from "./components/NewUsersModal";
import PipelineResultsModal from "./components/PipelineResultsModal";
import ReferralModal from "./components/ReferralModal";

import { MdBarChart, MdError, MdCallSplit, MdPersonAdd, MdPersonAddAlt, MdDataUsage, MdPeople, MdBlock } from "react-icons/md";
import BlockedUsersModal from "./components/BlockedUsersModal";

export default function DataTables() {
    const textColor = useColorModeValue("secondaryGray.900", "white");

    // Modal controls
    const {
        isOpen: isMonthlyTransfersOpen,
        onOpen: onMonthlyTransfersOpen,
        onClose: onMonthlyTransfersClose
    } = useDisclosure();

    const {
        isOpen: isFailedLoginsOpen,
        onOpen: onFailedLoginsOpen,
        onClose: onFailedLoginsClose
    } = useDisclosure();



    const {
        isOpen: isTransfersFunnelOpen,
        onOpen: onTransfersFunnelOpen,
        onClose: onTransfersFunnelClose
    } = useDisclosure();

    const {
        isOpen: isRegistrationFunnelOpen,
        onOpen: onRegistrationFunnelOpen,
        onClose: onRegistrationFunnelClose
    } = useDisclosure();

    const {
        isOpen: isNewUsersOpen,
        onOpen: onNewUsersOpen,
        onClose: onNewUsersClose
    } = useDisclosure();

    const {
        isOpen: isPipelineResultsOpen,
        onOpen: onPipelineResultsOpen,
        onClose: onPipelineResultsClose
    } = useDisclosure();

    const {
        isOpen: isReferralOpen,
        onOpen: onReferralOpen,
        onClose: onReferralClose
    } = useDisclosure();

    const {
        isOpen: isBlockedUsersOpen,
        onOpen: onBlockedUsersOpen,
        onClose: onBlockedUsersClose
    } = useDisclosure();

    const dataReports = [
        {
            id: "monthly-transfers",
            title: "צמיחה חודשית",
            description: "גרף העברות חודשיות ונתוני צמיחה",
            icon: MdBarChart,
            color: "blue",
            onClick: onMonthlyTransfersOpen
        },
        {
            id: "transfers-funnel",
            title: "Transfers Funnel",
            description: "ניתוח מפורט של תהליך ההעברה מהתחלה ועד סיום",
            icon: MdCallSplit,
            color: "teal",
            onClick: onTransfersFunnelOpen
        },
        {
            id: "registration-funnel",
            title: "Registration Funnel",
            description: "ניתוח מפורט של תהליך ההרשמה מהתחלה ועד סיום",
            icon: MdPersonAdd,
            color: "purple",
            onClick: onRegistrationFunnelOpen
        },
        {
            id: "failed-logins",
            title: "ניסיונות כניסה כושלים",
            description: "טבלת ניסיונות כניסה כושלים למערכת",
            icon: MdError,
            color: "red",
            onClick: onFailedLoginsOpen
        },
        {
            id: "new-users",
            title: "משתמשים חדשים",
            description: "רשימת משתמשים שנרשמו לאחרונה",
            icon: MdPersonAddAlt,
            color: "green.500",
            onClick: onNewUsersOpen
        },
        {
            id: "pipeline-results",
            title: "תוצאות צינורות נתונים",
            description: "צפייה בתוצאות עיבוד נתונים ושגיאות",
            icon: MdDataUsage,
            color: "orange",
            onClick: onPipelineResultsOpen
        },
        {
            id: "referrals",
            title: "Referral",
            description: "Top referrers and referral analytics",
            icon: MdPeople,
            color: "green",
            onClick: onReferralOpen
        },
        {
            id: "blocked-users",
            title: "משתמשים חסומים",
            description: "רשימת משתמשים חסומים ממערכת",
            icon: MdBlock,
            color: "red",
            onClick: onBlockedUsersOpen
        },

        // {
        //     id: "daily-logins",
        //     title: "כניסות יומיות",
        //     description: "גרף כניסות יומיות בחודשים האחרונים",
        //     icon: MdLogin,
        //     color: "green",
        //     onClick: onDailyLoginsOpen
        // },
        // {
        //     id: "user-activity",
        //     title: "פעילות משתמשים",
        //     description: "תרשים עוגה של משתמשים פעילים ולא פעילים",
        //     icon: MdPeople,
        //     color: "purple",
        //     onClick: onUserActivityOpen
        // },
    ];

    return (
        <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
            <Box mb="20px">
                <Heading size="lg" color={textColor} mb="4">
                    דוחות ונתונים
                </Heading>
                <Text color="secondaryGray.600" fontSize="md">
                    בחר דוח או נתונים לצפייה מפורטת
                </Text>
            </Box>

            <SimpleGrid
                columns={{ base: 1, md: 2, lg: 3 }}
                spacing="20px"
                mb="20px"
            >
                {dataReports.map((report) => (
                    <DataTableCard
                        key={report.id}
                        title={report.title}
                        description={report.description}
                        icon={report.icon}
                        color={report.color}
                        onClick={report.onClick}
                        buttonText={report.buttonText}
                    />
                ))}
            </SimpleGrid>

            {/* Modals */}
            <MonthlyTransfersModal
                isOpen={isMonthlyTransfersOpen}
                onClose={onMonthlyTransfersClose}
            />
            <FailedLoginsModal
                isOpen={isFailedLoginsOpen}
                onClose={onFailedLoginsClose}
            />

            <TransfersFunnelModal
                isOpen={isTransfersFunnelOpen}
                onClose={onTransfersFunnelClose}
            />
            <RegistrationFunnelModal
                isOpen={isRegistrationFunnelOpen}
                onClose={onRegistrationFunnelClose}
            />
            <NewUsersModal
                isOpen={isNewUsersOpen}
                onClose={onNewUsersClose}
            />
            <PipelineResultsModal
                isOpen={isPipelineResultsOpen}
                onClose={onPipelineResultsClose}
            />
            <ReferralModal
                isOpen={isReferralOpen}
                onClose={onReferralClose}
            />
            <BlockedUsersModal
                isOpen={isBlockedUsersOpen}
                onClose={onBlockedUsersClose}
            />

        </Box>
    );
}
